import { useEffect, useState } from "react"
import { globalHistory } from "@reach/router"

/**
 * @deprecated
 * use graphql to get and render page pathname
 * pathname from graphql is available at SSR stage
 *
 */
export default function useCurrentPathname(): string | null {
  const [currentPathName, setCurrentPathName] = useState<string | null>(null)

  useEffect(() => {
    const pathName = globalHistory.location.pathname

    if (pathName) {
      setCurrentPathName(pathName)
    }
  }, [setCurrentPathName])

  return currentPathName
}
